export const validateCurrency = (string) => {
    // Expressão regular para validar o formato monetário
    const regex = /^\d{1,3}(\.\d{3})*(,\d{2,})?$/;

    // Verificar se a string corresponde ao formato monetário
    return regex.test(string);
}

export const formatCurrency = (numero, decimal, symbol) => {
  // Converte o número para string, se necessário
  numero = numero.toString();

  if (symbol === undefined) {
      symbol = 'R$'; 
    }

  if (decimal === undefined) {
      decimal = 2;
  } 

  // Verifica se o número já está no formato correto (com casas decimais separadas por virgula)
  if (/,/.test(numero)) {
      return `${symbol} ${numero}`;
  }

  // Adiciona ponto como separador de milhar
  let partes = numero.split('.');
  partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  // Adiciona duas casas decimais se não houver
  if (partes.length === 1) {
      partes.push(''.padEnd(decimal, '0'));
  } else if (partes[1].length < 2) {
      partes[1] = partes[1].padEnd(decimal, '0');
  } else if (partes[1].length > decimal) {
      partes[1] = partes[1].slice(0, decimal);
  }

  // Adiciona o símbolo de real
  return `R$ ${partes.join(',')}`;
};

export const formatDecimal = (numero, decimal) => {
  // Converte o número para string, se necessário
  numero = numero.toString();

  if (decimal === undefined) {
      decimal = 2;
  } 

  // Verifica se o número já está no formato correto (com casas decimais separadas por virgula)
  if (/,/.test(numero)) {
      return `${numero}`;
  }

  // Adiciona ponto como separador de milhar
  let partes = numero.split('.');
  partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  // Adiciona duas casas decimais se não houver
  if (partes.length === 1) {
      partes.push(''.padEnd(decimal, '0'));
  } else if (partes[1].length < 2) {
      partes[1] = partes[1].padEnd(decimal, '0');
  } else if (partes[1].length > decimal) {
      partes[1] = partes[1].slice(0, decimal);
  }

  // Adiciona o símbolo de real
  return `${partes.join(',')}`;
};